import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { matchesDefaultRequirementListMonthRange } from '../../utils/requirementDateFilter';

function SearchIcon() {
  return (
    <svg
      className="hr-requirements-filter-search-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M7.25 12.5a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Zm0-1.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm4.94 2.06-2.8-2.8 1.06-1.06 2.8 2.8-1.06 1.06Z"
        fill="currentColor"
      />
    </svg>
  );
}

function TLRequirementFilterBar({
  searchQuery,
  onSearchChange,
  fromDate,
  toDate,
  onFromChange,
  onToChange,
  onClear,
}) {
  const hasActiveFilters = Boolean(
    searchQuery || !matchesDefaultRequirementListMonthRange(fromDate, toDate)
  );

  return (
    <div className="hr-requirements-filter-bar">
      <div className="hr-requirements-filter-search-wrap">
        <label className="hr-requirements-filter-label" htmlFor="tl-requirements-search">
          Search
        </label>
        <div className="hr-requirements-filter-search-input">
          <SearchIcon />
          <Form.Control
            id="tl-requirements-search"
            type="text"
            inputMode="search"
            autoComplete="off"
            className="hr-requirements-filter-search-field"
            placeholder="Search by ID, client, or role"
            value={searchQuery}
            onChange={(event) => onSearchChange(event.target.value)}
            aria-label="Search requirements"
          />
          {searchQuery ? (
            <button
              type="button"
              className="hr-requirements-filter-search-clear"
              onClick={() => onSearchChange('')}
              aria-label="Clear search"
            >
              ×
            </button>
          ) : null}
        </div>
      </div>

      <div className="hr-requirements-filter-field">
        <label className="hr-requirements-filter-label" htmlFor="tl-requirements-from-date">
          From Date
        </label>
        <Form.Control
          id="tl-requirements-from-date"
          type="date"
          className="hr-date-input"
          value={fromDate || ''}
          onChange={(event) => onFromChange(event.target.value)}
          aria-label="From date"
        />
      </div>

      <div className="hr-requirements-filter-field">
        <label className="hr-requirements-filter-label" htmlFor="tl-requirements-to-date">
          To Date
        </label>
        <Form.Control
          id="tl-requirements-to-date"
          type="date"
          className="hr-date-input"
          value={toDate || ''}
          onChange={(event) => onToChange(event.target.value)}
          aria-label="To date"
        />
      </div>

      <div className="hr-requirements-filter-actions">
        <span className="hr-requirements-filter-label hr-requirements-filter-label-spacer" aria-hidden="true">
          &nbsp;
        </span>
        <Button
          variant="outline-secondary"
          size="sm"
          className="hr-requirements-filter-reset"
          type="button"
          onClick={onClear}
          disabled={!hasActiveFilters}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
}

export default TLRequirementFilterBar;
